import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { useGenericErrorStore } from '@/store/useGenericErrorStore'

const GENERIC_ERROR_PATH = '/fallback/erro-generico'

export function GenericErrorRedirect() {
  const navigate = useNavigate()
  const pathname = useLocation().pathname
  const shouldRedirectToGenericError = useGenericErrorStore(
    (state) => state.shouldRedirectToGenericError
  )
  const setShouldRedirectToGenericError = useGenericErrorStore(
    (state) => state.setShouldRedirectToGenericError
  )

  useEffect(() => {
    if (!shouldRedirectToGenericError) {
      return
    }

    if (pathname !== GENERIC_ERROR_PATH) {
      navigate(GENERIC_ERROR_PATH, { replace: true })
    }

    setShouldRedirectToGenericError(false)
  }, [
    navigate,
    pathname,
    setShouldRedirectToGenericError,
    shouldRedirectToGenericError
  ])

  return null
}
